<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Sistema de Salud</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('seguros.store')"
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_regimenes"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="6" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="seguros"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todos los Seguros de Salud
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.nombre="{ item }">
                <span class="font-weight-medium">{{ item.nombre }}</span>
              </template>

              <template v-slot:item.monto="{ item }">
                <span class="font-weight-medium">S/ {{ item.monto }}</span>
              </template>

              <template v-slot:item.porcentaje="{ item }">
                <span class="font-weight-medium">{{ item.porcentaje }} %</span>
              </template>

              <template v-slot:item.activo="{ item }">
                <span v-if="item.activo" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="this.$hasPermision('seguros.update')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <v-btn
              v-if="show_btn_active && this.$hasPermision('seguros.update')"
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="!show_btn_active && this.$hasPermision('seguros.update')"
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('seguros.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/seguros/CreateUpdate";

export default {
  name: "Regimenes",
  components: {
    CreateUpdate,
    OfficeLogin,
  },
  data() {
    //variables
    return {
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      search_regimenes: null,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Sistema de Salud",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "NOMBRE SEGURO", value: "nombre" },
        { text: "MONTO", value: "monto" },
        { text: "PORCENTAJE", value: "porcentaje" },
        { text: "ESTADO", value: "activo" },
      ],
    };
  },
  computed: {
    ...mapState("seguros", ["seguros"]),
  },
  methods: {
    //funciones
    ...mapActions("seguros", ["getSeguros", "change_status", "delete"]),
    async listarSeguros() {
      await this.getSeguros();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo Seguro de Salud", "create");
    },
    handleShowFilters() {
      // console.log('filtros');
    },
    handleSearch() {
      // console.log('buscar')
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].activo;
      }
    },
    handleEdit() {
      let color = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de Régimen Pensionario",
        "update",
        color
      );
    },
    async handleChangeStatus() {
      let seguro = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(seguro);
    },
    async handleDelete() {
      let seguro = this.selectedRows[0];
      this.selectedRows = [];
      await this.delete(seguro);
      this.showOptionCrud();
    },
    handleInputSearchByEnter() {
      // console.log('asd');
    },
  },
  created() {
    this.listarSeguros();
  },
};
</script>
<style scope></style>
